import {
  Dropdown, Flex, MenuProps, Grid
} from "antd";

import { useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import classes from "./navigation.module.css";

const { useBreakpoint } = Grid;

const items: MenuProps["items"] = [
  {
    label: (
      <NavLink
        to="/chi-siamo"
        className={({ isActive }) => (isActive ? "font-bold" : undefined)}
      >
        Il progetto
      </NavLink>
    ),
    icon: (
      <svg width="24" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 18V15H4C2.34315 15 1 16.3431 1 18M5.8 21H13.8C14.9201 21 15.4802 21 15.908 20.782C16.2843 20.5903 16.5903 20.2843 16.782 19.908C17 19.4802 17 18.9201 17 17.8V4.2C17 3.07989 17 2.51984 16.782 2.09202C16.5903 1.71569 16.2843 1.40973 15.908 1.21799C15.4802 1 14.9201 1 13.8 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z" stroke="#204480" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    key: "0",
  },
  {
    label: (
      <NavLink
        to="/psiconcologi"
        className={({ isActive }) => (isActive ? "font-bold" : undefined)}
      >
        Chi siamo
      </NavLink>
    ),
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#204480" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.8333 7.3C13.8333 7.01997 13.8333 6.87996 13.7788 6.773C13.7309 6.67892 13.6544 6.60243 13.5603 6.5545C13.4534 6.5 13.3134 6.5 13.0333 6.5H10.9667C10.6866 6.5 10.5466 6.5 10.4397 6.5545C10.3456 6.60243 10.2691 6.67892 10.2212 6.773C10.1667 6.87996 10.1667 7.01997 10.1667 7.3V9.36667C10.1667 9.64669 10.1667 9.78671 10.1122 9.89366C10.0642 9.98774 9.98774 10.0642 9.89366 10.1122C9.78671 10.1667 9.64669 10.1667 9.36667 10.1667H7.3C7.01997 10.1667 6.87996 10.1667 6.773 10.2212C6.67892 10.2691 6.60243 10.3456 6.5545 10.4397C6.5 10.5466 6.5 10.6866 6.5 10.9667V13.0333C6.5 13.3134 6.5 13.4534 6.5545 13.5603C6.60243 13.6544 6.67892 13.7309 6.773 13.7788C6.87996 13.8333 7.01997 13.8333 7.3 13.8333H9.36667C9.64669 13.8333 9.78671 13.8333 9.89366 13.8878C9.98774 13.9358 10.0642 14.0123 10.1122 14.1063C10.1667 14.2133 10.1667 14.3533 10.1667 14.6333V16.7C10.1667 16.98 10.1667 17.12 10.2212 17.227C10.2691 17.3211 10.3456 17.3976 10.4397 17.4455C10.5466 17.5 10.6866 17.5 10.9667 17.5H13.0333C13.3134 17.5 13.4534 17.5 13.5603 17.4455C13.6544 17.3976 13.7309 17.3211 13.7788 17.227C13.8333 17.12 13.8333 16.98 13.8333 16.7V14.6333C13.8333 14.3533 13.8333 14.2133 13.8878 14.1063C13.9358 14.0123 14.0123 13.9358 14.1063 13.8878C14.2133 13.8333 14.3533 13.8333 14.6333 13.8333H16.7C16.98 13.8333 17.12 13.8333 17.227 13.7788C17.3211 13.7309 17.3976 13.6544 17.4455 13.5603C17.5 13.4534 17.5 13.3134 17.5 13.0333V10.9667C17.5 10.6866 17.5 10.5466 17.4455 10.4397C17.3976 10.3456 17.3211 10.2691 17.227 10.2212C17.12 10.1667 16.98 10.1667 16.7 10.1667H14.6333C14.3533 10.1667 14.2133 10.1667 14.1063 10.1122C14.0123 10.0642 13.9358 9.98774 13.8878 9.89366C13.8333 9.78671 13.8333 9.64669 13.8333 9.36667V7.3Z" stroke="#204480" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    key: "1",
  },
  {
    label: (
      <NavLink
        to="/faq"
        className={({ isActive }) => (isActive ? "font-bold" : undefined)}
      >
        Domande frequenti
      </NavLink>
    ),
    icon: (
      <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.49865 7.00224C9.67485 6.50136 10.0226 6.079 10.4804 5.80998C10.9381 5.54095 11.4763 5.4426 11.9997 5.53237C12.523 5.62213 12.9977 5.89421 13.3396 6.30041C13.6815 6.70661 13.8687 7.22072 13.8679 7.75168C13.8679 9.25056 11.6196 10 11.6196 10M11.6486 13H11.6586M11.4986 18C16.1931 18 19.9986 14.1944 19.9986 9.5C19.9986 4.80558 16.1931 1 11.4986 1C6.80423 1 2.99865 4.80558 2.99865 9.5C2.99865 10.45 3.1545 11.3636 3.44202 12.2166C3.55022 12.5376 3.60432 12.6981 3.61408 12.8214C3.62371 12.9432 3.61643 13.0286 3.5863 13.1469C3.5558 13.2668 3.48844 13.3915 3.35374 13.6408L1.71808 16.6684C1.48477 17.1002 1.36812 17.3161 1.39423 17.4828C1.41697 17.6279 1.5024 17.7557 1.62782 17.8322C1.77183 17.9201 2.01595 17.8948 2.50419 17.8444L7.62521 17.315C7.78029 17.299 7.85783 17.291 7.92851 17.2937C7.99802 17.2963 8.04709 17.3029 8.11488 17.3185C8.1838 17.3344 8.27047 17.3678 8.4438 17.4345C9.39185 17.7998 10.4219 18 11.4986 18Z" stroke="#204480" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    key: "2",
  },
  {
    label: (
      <NavLink
        to="/contatti"
        className={({ isActive }) => (isActive ? "font-bold" : undefined)}
      >
        Contatti
      </NavLink>
    ),
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.99865 14C8.99865 14 10.3111 15.5 12.4986 15.5C14.6861 15.5 15.9986 14 15.9986 14M15.2486 9H15.2586M9.74865 9H9.75865M12.4986 20C17.1931 20 20.9986 16.1944 20.9986 11.5C20.9986 6.80558 17.1931 3 12.4986 3C7.80423 3 3.99865 6.80558 3.99865 11.5C3.99865 12.45 4.1545 13.3636 4.44202 14.2166C4.55022 14.5376 4.60432 14.6981 4.61408 14.8214C4.62371 14.9432 4.61643 15.0286 4.5863 15.1469C4.5558 15.2668 4.48844 15.3915 4.35374 15.6408L2.71808 18.6684C2.48477 19.1002 2.36812 19.3161 2.39423 19.4828C2.41697 19.6279 2.5024 19.7557 2.62782 19.8322C2.77183 19.9201 3.01595 19.8948 3.50419 19.8444L8.62521 19.315C8.78029 19.299 8.85783 19.291 8.92851 19.2937C8.99802 19.2963 9.04709 19.3029 9.11488 19.3185C9.1838 19.3344 9.27047 19.3678 9.4438 19.4345C10.3919 19.7998 11.4219 20 12.4986 20ZM15.7486 9C15.7486 9.27614 15.5248 9.5 15.2486 9.5C14.9725 9.5 14.7486 9.27614 14.7486 9C14.7486 8.72386 14.9725 8.5 15.2486 8.5C15.5248 8.5 15.7486 8.72386 15.7486 9ZM10.2486 9C10.2486 9.27614 10.0248 9.5 9.74865 9.5C9.47251 9.5 9.24865 9.27614 9.24865 9C9.24865 8.72386 9.47251 8.5 9.74865 8.5C10.0248 8.5 10.2486 8.72386 10.2486 9Z" stroke="#204480" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    key: "3",
  },
];

const Navigation = () => {
  const { lg } = useBreakpoint();
  const dropdownRef = useRef(null);
  const location = useLocation();

  const isDropdownActive = items.some(item => {
    if (item && "label" in item && item.label && typeof item.label === "object" && "props" in item.label) {
      const itemPath = (item.label as any).props?.to;
      return itemPath && location.pathname === itemPath;
    }
    return false;
  });

  const selectedKey = items.find(item => {
    if (item && "label" in item && item.label && typeof item.label === "object" && "props" in item.label) {
      const itemPath = (item.label as any).props?.to;
      return itemPath && location.pathname === itemPath;
    }
    return false;
  })?.key;

  return (
    <Flex gap={32} vertical={!lg} align="center" justify="center" className={classes.root}>
      <Dropdown
        menu={{
          items,
          selectable: true,
          selectedKeys: selectedKey ? [String(selectedKey)] : []
        }}
        trigger={["click"]}
        placement="bottomLeft"
        overlayClassName={classes.dropdown}
        getPopupContainer={!lg ? () => dropdownRef.current! : undefined}
      >
        <div>
          <Flex gap={4} align="center" className={classes.item}>
            <span className={`${classes.link} ${isDropdownActive ? "font-bold" : ""}`}>Chi siamo</span>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.5 7.5L10.5 12.5L15.5 7.5" stroke="#1018288c" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Flex>
          <div className={classes.mobileDropdown} ref={dropdownRef} />
        </div>
      </Dropdown>
      <Flex gap={8} align="center" className={classes.item}>
        <NavLink
          to="/come-funziona"
          className={({ isActive }) => `${classes.link} ${isActive ? "font-bold" : ""}`}
        >
          Come funziona
        </NavLink>
      </Flex>
      <Flex gap={8} align="center" className={classes.item}>
        <NavLink
          to="/psiconcologia"
          className={({ isActive }) => `${classes.link} ${isActive ? "font-bold" : ""}`}
        >
          Psiconcologia
        </NavLink>
      </Flex>
    </Flex>
  );
};

export default Navigation;
